<script>
export default {
  created() {
    localStorage.removeItem("admin");
    this.$router.push("/login");
  },
};
</script>
